<template>
	<el-dialog :visible.sync="show"
		:title="$t('privateNetwork.openIpv6')"
		:close-on-click-modal="false"
		:before-close="handleClose"
		class="open-ipv6-root">
		<el-alert
		    :title="$t('privateNetInstance.enableIpv6Tip')"
		    type="info"
		    :closable="false">
		</el-alert>
        <el-form class="jc-form cps-create-form" label-width="130px"
        	ref="ruleForm" :rules="ruleForm"
        	:model="ipv6Form">
        	<!--目标网络接口名称-->
            <el-form-item :label="$t('eip.text.targetInternetAccessName') | withColon" >
                <el-radio-group v-model="selectTargetInternetAccessName" @change="changeTargetInternetAccessName">
                    <el-radio-button v-for="item in targetInternetAccessNames" :key="item.label" :label="item.label">
                        {{item.value}}
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>
	        <!--所属子网-->
	        <el-form-item :label="$t('privateNetInstance.subnetBelongTo') | withColon">
                {{ (selectTargetInternetAccessName === 'primary' ? currentRow.subnetName : currentRow.extensionSubnetName) || '--'}}
                <!-- {{  currentRow.subnetName}} -->
                <!-- 辅网口 extensionSubnetName -->
	        </el-form-item>
	       	<el-form-item :label="$t('privateNetInstance.subnetIpv6Cidr') | withColon">
	       		{{ (selectTargetInternetAccessName === 'primary' ? currentRow.subnetIpv6Cidr : currentRow.extensionSubnetIpv6Cid) || '--'}}
	       		<!-- {{ currentRow.subnetIpv6Cidr}} -->
                <!-- 辅网口 网段 extensionSubnetIpv6Cidr -->
	     	</el-form-item>
	     	<el-form-item :label="$t('privateNetInstance.operations.ipv6') | withColon" class="w600">
	     		<div class="ip-input">
	     			<el-form-item>
						<el-select
                            v-model="isPrivateIpv6Auto"
                            :disabled="(selectTargetInternetAccessName === 'primary' && !currentRow.subnetIpv6Cidr) || (selectTargetInternetAccessName === 'sub' && !currentRow.extensionSubnetIpv6Cid)"
                            @change="clearInputIp">
							<el-option v-for="(operate, index) in ipOperations"
								:key="index"
								:value="operate.value"
								:label="operate.label">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="privateIpv6">
						<span v-if="!isPrivateIpv6Auto"
							class="ml10">{{privateIpv6Pre}}</span>
                            <!-- 自动分配，输入框不可输入 -->
						<el-input
							:disabled="isPrivateIpv6Auto === 1 || (selectTargetInternetAccessName === 'primary' && !currentRow.subnetIpv6Cidr) || (selectTargetInternetAccessName === 'sub' && !currentRow.extensionSubnetIpv6Cid)"
							class="inner-ip"
							:class="{'ipv6': !isPrivateIpv6Auto}"
							v-model="ipv6Form.privateIpv6"
							:placeholder="isPrivateIpv6Auto ? $t('privateNetInstance.autoIpTip') : $t('privateNetInstance.notAutoIpv6Tip')">
						</el-input>
					</el-form-item>
	     		</div>
	     	</el-form-item>
    	</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="cancelDel">{{ $t('privateNetwork.cancel') }}</el-button>
			<el-button
                @click="sureDel"
                :disabled="(selectTargetInternetAccessName === 'primary' && !currentRow.subnetIpv6Cidr) || (selectTargetInternetAccessName === 'sub' && !currentRow.extensionSubnetIpv6Cid)"
                type="primary">
                {{ $t('privateNetwork.sure') }}
            </el-button>
		</div>
	</el-dialog>
</template>

<script>
import {isIpv6} from '@/common/tool';
export default {
	name: 'ipv6PrivateNetInstance',
	components: {
	},
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		region: {
			type: String,
			default: ''
		},
		currentRow: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		const validateIpv6Address = (rule, value, callback) => {
			const reg = /^\\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:)))(%.+)?\\s*$/;
			let ipv6 = this.privateIpv6Pre + this.ipv6Form.privateIpv6;
			if (!this.isPrivateIpv6Auto) {
				if (this.ipv6Form.privateIpv6.trim() == '') {
					callback(new Error(this.$t('create.placeholder.default')));
				}
				if (!isIpv6(ipv6)) {
					callback(new Error(this.$t('create.placeholder.ipv6AddressNotPass')));
				} else {
					callback();
				}
			} else {
				callback();
			}
		};
		return {
			show: false,
			ipv6Form: {
				privateIpv6: ''
			},
			ruleForm: {
				privateIpv6: [
					{

						validator: validateIpv6Address,
						trigger: 'blur'
					}
				]
			},
            ipOperations: [
				{
					value: 1,
					label: this.$t('privateNetInstance.auto') // 自动分配
				},
				{
					value: 0,
					label: this.$t('privateNetInstance.handwrite') // 手动分配
				}
			],
			isPrivateIpv6Auto: 1,
			selectTargetInternetAccessName: 'primary',
		};
	},
	computed: {
		privateIpv6Pre() {
			let selectSubnetIpv6Cidr = this.selectTargetInternetAccessName === 'primary' ? this.currentRow.subnetIpv6Cidr : this.currentRow.extensionSubnetIpv6Cidr;
			if (selectSubnetIpv6Cidr) {
				return  selectSubnetIpv6Cidr.split('::')[0] + ':'
			}
			return ''
		},
		//目标网络接口名称
        targetInternetAccessNames() {
            let interfaceMode = this.currentRow.interfaceMode;
            if (interfaceMode === 'bond') {
                return [
                    {
                        label: 'primary',
                        value: this.$t('eip.text.singleInternetAccessChiefName')
                    }
                ];
            } else if (interfaceMode === 'dual') {
                return [
                    {
                        label: 'primary',
                        value: this.$t('eip.text.chiefInternetAccessName') // 主网口
                    },
                    {
                        label: 'sub',
                        value: this.$t('eip.text.subInternetAccessName') // 符网口
                    }
                ];
            }
        },

        subnetId() {
        	return this.selectTargetInternetAccessName === 'primary' ? this.currentRow.subnetId : this.currentRow.extensionSubnetId
        }
	},
	watch: {
		visible(newVal) {
			this.show = newVal;
		},
		currentRow(newVal) {
		}
	},
	methods: {
		// 切换目标网络接口名称
        changeTargetInternetAccessName(label) {
            console.log('999', label)
            if (label === 'sub') {
                this.ipv6Form.privateIpv6 = ''
            }
            // this.subnetId = label === 'primary' ? this.currentRow.subnetId : this.currentRow.extensionSubnetId
        },
		handleClose() {
			this.show = false;
			this.$emit('update:visible', false);
		},
		cancelDel() {
			this.handleClose();
		},
		sureDel() {
			let formValid = true;
			this.$refs.ruleForm.validate((valid) => {
				formValid = valid;
			});
			if (!formValid) {
				return
			}
			const params = {
				region: this.region,
				instanceId: this.currentRow.instanceId,
				subnetId: this.subnetId,
				clientToken: Normal.getClientToken()
			};
			if (!this.isPrivateIpv6Auto) { // 1 自动分配，0 手动分配
				this.ipv6Address = this.privateIpv6Pre + this.ipv6Form.privateIpv6
                // 手动分配，传入当前IP，以便接口过滤自身
                params.ipv6Address = this.privateIpv6Pre + this.ipv6Form.privateIpv6
			}
			Ajax.post('/api/cps/assignIpv6Address', params)
			.then((res) => {
				this.$message.success(this.$t('privateNetInstance.operateSuccess'));
				this.$emit('refresh');
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch(ex) {
					console.log(ex);
				}
			})
			.finally(() => {
				this.handleClose();
			});
		},
		clearInputIp() {
			this.ipv6Form.privateIpv6 = '';
		},
	},
};
</script>

<style lang="scss">
	@import "ipv6PrivateNetInstance";
</style>



// WEBPACK FOOTER //
// src/components/privateNetInstance/ipv6PrivateNetInstance/ipv6PrivateNetInstance.vue